import RegisterRewardCard from './RegisterRewardCard';

export default RegisterRewardCard;
